<template>
  <div>
    <b-row v-if="item && Object.keys(item).length">
      <b-col md="12">
        <b-row>
          <b-col>
            <b-alert
              class="text-center"
              :show="!!item.ticket_finished"
              variant="danger"
              v-text="$lang.ticketLang.cant_edit_ticket"
            />
          </b-col>
        </b-row>
        <b-row
          v-if="accessLevel === 'admin'"
          class="mx-0 mb-3 bg-light rounded p-3"
        >
          <b-col
            v-if="item.parvandeh && item.parvandeh.term"
            md=""
            cols="12"
            class="text-center text_sm_right px-0"
          >
            <strong v-text="`${$lang.ticketLang.term}: `" />
            <span
              class="text-muted"
              v-text="
                (item.parvandeh.term && item.parvandeh.term.caption) || ''
              "
            />
          </b-col>
          <b-col
            v-if="item.parvandeh && item.parvandeh.parvandeh_number"
            md=""
            cols="12"
            class="text-center text_sm_right px-0"
          >
            <strong v-text="`${$lang.ticketLang.parvande_number}: `" />
            <span
              class="text-muted"
              v-text="(item.parvandeh && item.parvandeh.parvandeh_number) || ''"
            />
          </b-col>

          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong v-text="`${$lang.ticketLang.audience}: `" />
            <ProfileBoxPopupWrapper
              :data="item.user"
              deskTopPopupClass="top-230"
              nameClass="color-complementary"
            >
              <span class="cursor--pointer color-complementary">
                {{ senderName }}
              </span>
            </ProfileBoxPopupWrapper>
          </b-col>
          <b-col
            v-if="item.user && item.user.national_code"
            md=""
            cols="12"
            class="text-center text_sm_right px-0"
          >
            <strong
              v-text="`${$lang.ticketLang.ticket_page.national_code}: `"
            />
            <span
              class="text-muted"
              v-text="(item.user && item.user.national_code) || ''"
            />
          </b-col>

          <b-col
            v-if="item.user && item.user.username"
            md=""
            cols="12"
            class="text-center text_sm_right px-0"
          >
            <strong v-text="`${$lang.ticketLang.ticket_page.username}: `" />
            <span
              class="text-muted"
              v-text="(item.user && item.user.username) || ''"
            />
          </b-col>
        </b-row>
        <b-row class="m-0 mb-3 bg-light rounded p-3">
          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong
              v-text="`${$lang.ticketLang.ticket_page.mobile_number}: `"
            />
            <span
              class="text-muted"
              v-text="(item.user && item.user.mobile) || ''"
            />
          </b-col>
          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong v-text="`${$lang.ticketLang.ticket_page.created_at}: `" />
            <span
              class="text-muted"
              v-text="item.created_at && item.created_at.jalali"
            />
          </b-col>
          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong v-text="`${$lang.ticketLang.ticket_page.updated_at}: `" />
            <span
              class="text-muted"
              v-text="item.updated_at && item.updated_at.jalali"
            />
          </b-col>
          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong v-text="`${$lang.ticketLang.ticket_page.status}: `" />
            <span
              class="text-muted"
              v-text="item.ticket_status_id && item.ticket_status_id.caption"
            />
          </b-col>
          <b-col md="" cols="12" class="text-center text_sm_right px-0">
            <strong v-text="`${$lang.ticketLang.ticket_page.unit}: `" />
            <span
              class="text-muted"
              v-text="item.ticket_unit_id && item.ticket_unit_id.caption"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mb-3">
            <i class="fas fa-edit mr-2" />
            <b v-text="`${$lang.ticketLang.ticket_page.ticket_title}: `" />
            <span class="text-muted" v-text="item.ticket_subject" />
          </b-col>
        </b-row>
      </b-col>
      <b-col md="12">
        <b-row>
          <b-col>
            <div class="accordion" v-if="item.details">
              <b-card
                no-header
                no-body
                class="border-0 message_card mb-3"
                v-for="(detail, index) in item.details"
                :key="index"
              >
                <b-row
                  class="m-0 py-2 border-0"
                  :class="
                    getUserRoles(detail.ticket_sender_group.id, 'bgClass')
                  "
                >
                  <b-col md="6" cols="12" class="">
                    <div
                      class="d-flex align-items-center justify-content-start"
                    >
                      <img
                        v-if="accessLevel === 'admin'"
                        :src="
                          pathOr(null, ['user', 'img_kind'], detail) &&
                          detail.user.img_kind.find((x) => x.type == `avatar`)
                            ? detail.user.img_kind.find(
                                (x) => x.type == `avatar`
                              ).address
                            : sampleAvatar
                        "
                        @error="errorImg"
                        class="img-thumbnail user_avatar rounded-circle"
                      />
                      <div class="name ml-2">
                        <strong
                          v-text="
                            (detail.user && detail.user.name) ||
                            getUserRoles(detail.ticket_sender_group.id, 'name')
                          "
                        />
                        <div class="mt-1">
                          <i
                            :class="
                              getUserRoles(
                                detail.ticket_sender_group.id,
                                'icon'
                              )
                            "
                          />
                          <small
                            class="p-0 ml-1"
                            v-text="
                              getUserRoles(
                                detail.ticket_sender_group.id,
                                'role'
                              )
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    cols="12"
                    class="d-flex align-items-end justify-content-center flex-column"
                  >
                    <div
                      :title="$lang.ticketLang.ticket_page.created_at"
                      v-b-tooltip.hover
                    >
                      <strong
                        v-text="detail.created_at && detail.created_at.jalali"
                      />
                      <i class="far fa-clock ml-2" />
                    </div>
                    <div
                      v-if="
                        detail.user_seen_date && detail.user_seen_date.jalali
                      "
                      :title="$lang.ticketLang.ticket_page.visited_at"
                      v-b-tooltip.hover
                    >
                      <strong
                        v-text="
                          detail.user_seen_date && detail.user_seen_date.jalali
                        "
                      />
                      <i class="fas fa-eye ml-2" />
                    </div>
                  </b-col>
                </b-row>
                <b-card-body class="card-body-text">
                  <b-card-text>
                    <b-row>
                      <b-col
                        :md="detail.has_attachment ? 9 : 12"
                        cols="12"
                        v-html="nl2br(detail.description)"
                      />
                      <b-col
                        v-if="detail.has_attachment"
                        md="3"
                        cols="12"
                        class="border-right border_sm_none mt-md-0 mt-3"
                      >
                        <b-button
                          variant="outline-dark"
                          block
                          :title="
                            $lang.ticketLang.ticket_page.click_for_show_files
                          "
                          v-b-tooltip.hover
                          @click="openModal(detail)"
                        >
                          <i class="fas fa-paperclip" />
                          {{ $lang.ticketLang.ticket_page.show_files_attached }}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-card-text>
                </b-card-body>
              </b-card>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="!item.ticket_finished" class="mx-0">
          <b-col class="bg-light py-3 mb-3 rounded">
            <b-alert v-if="accessLevel === 'admin'" variant="primary" show>
              <b-row>
                <b-col md="8" cols="12">
                  <strong>
                    <i class="fa fa-info-circle" />
                    {{ $lang.ticketLang.send_sms_alert }}
                  </strong>
                </b-col>
                <b-col md="4" cols="12" class="text-md-right text-center">
                  <b-button
                    :disabled="btnloading"
                    @click="handleModal('sendMessage')"
                    variant="primary"
                  >
                    <i class="fas fa-sms fa-lg mr-2" />
                    {{ $lang.ticketLang.ticket_page.send_sms }}
                  </b-button>
                </b-col>
              </b-row>
            </b-alert>
            <b-alert v-if="accessLevel === 'admin'" variant="primary" show>
              <b-row>
                <b-col cols="12" md="8">
                  <strong>
                    <i class="fa fa-info-circle" />
                    {{ $lang.ticketLang.target_unit_alert }}
                  </strong>
                </b-col>
                <b-col cols="12" md="4" class="text-md-right text-center">
                  <b-button
                    :disabled="btnloading"
                    @click="handleModal('targetUnit')"
                    variant="primary"
                  >
                    <i class="fas fa-bullhorn fa-lg mr-2" />
                    {{ $lang.ticketLang.ticket_page.move_to_other_unit }}
                  </b-button>
                </b-col>
              </b-row>
            </b-alert>
            <b-alert v-if="accessLevel === 'user'" variant="danger" show>
              <b-row>
                <b-col cols="12" md="8">
                  <strong>
                    <i class="fa fa-info-circle" />
                    {{ $lang.ticketLang.change_state_alert }}
                  </strong>
                </b-col>
                <b-col cols="12" md="4" class="text-md-right text-center">
                  <b-button
                    :disabled="btnloading"
                    @click="confirmData.show = true"
                    variant="danger"
                  >
                    <i class="far fa-calendar-times fa-lg mr-2" />
                    {{ $lang.ticketLang.end_ticket }}
                  </b-button>
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="item.ticket_finished">
            <b-button
              block
              variant="danger"
              class="mb-3 py-3"
              @click="closePage"
            >
              <i class="fas fa-times mr-2" />
              <strong v-text="$lang.ticketLang.ticket_page.close_page" />
            </b-button>
          </b-col>
          <b-col v-else>
            <b-button
              v-if="!item.ticket_finished"
              block
              variant="primary"
              class="py-3"
              v-b-toggle.create_message
            >
              <i class="fas fa-plus mr-2" />
              <strong
                v-text="$lang.ticketLang.ticket_page.create_new_message"
              />
            </b-button>
            <b-collapse id="create_message" class="bg-light p-3 mt-3">
              <b-overlay :show="btnloading || loading">
                <b-form-group
                  :label="$lang.ticketLang.description"
                  label-for="ticket_status"
                  :label-cols="$config.form.labelCol"
                >
                  <b-form-textarea
                    :disabled="btnloading"
                    v-model="$v.description.$model"
                    class="m-0"
                    :placeholder="$lang.ticketLang.description"
                    rows="5"
                    :aria-invalid="true"
                  >
                  </b-form-textarea>
                </b-form-group>
                <b-form-group
                  v-if="accessLevel === 'admin'"
                  :label="$lang.ticketLang.ticket_status"
                  label-for="ticket_status"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.ticketLang.ticket_status"
                    :rules="$v.ticket_status_selected.$params"
                  />
                  <selectFind
                    :options="ticket_status_options"
                    v-model="$v.ticket_status_selected.$model"
                    label="text"
                    id="value"
                    :isValid="
                      $v.ticket_status_selected.$dirty
                        ? !$v.ticket_status_selected.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.ticket_status_selected.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="ticket_status_selected_feedback"
                  >
                    {{
                      $lang.ticketLang.error_required
                        | replace($lang.ticketLang.ticket_status_selected)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <AttachFile
                  ref="attachFile"
                  class="mb-2 bg-white mb-3 attach_file_box"
                  @responseCode="setResponseCode"
                  :acceptFormats="acceptFormats"
                />
                <b-row>
                  <b-col md="3" cols="12" class="text-center mb-2">
                    <b-button
                      @click="submit"
                      variant="success"
                      block
                      :disabled="btnloading"
                    >
                      {{ $lang.ticketLang.send }}
                      <i class="fa fa-check" />
                    </b-button>
                  </b-col>
                  <b-col md="3" cols="12" class="text-center mb-2">
                    <b-button
                      :disabled="btnloading"
                      variant="outline-danger"
                      block
                      v-b-toggle.create_message
                      @click="closePage"
                    >
                      {{ $lang.ticketLang.cancelButton }}
                      <i class="fa fa-ban"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-collapse>
          </b-col>
        </b-row>
      </b-col>
      <b-modal
        no-close-on-backdrop
        variant="primary"
        header-bg-variant="primary"
        content-class="border-primary"
        v-model="viewModal"
        size="xl"
        ok-only
        hide-header
      >
        <b-overlay :show="loading">
          <b-row v-if="modalMode === 'uploadFiles'">
            <b-col cols="12">
              <UploadFile
                v-if="file_id"
                caption="پیوست تحقیق"
                attachment_type_name="attachment_type_ticket"
                attachmentRoute="attachment_ticket"
                :keyServies="`ticket_detail`"
                :keyValue="file_id"
                :file_types="file_types"
                :parentPermissions="parentPermissions"
                :allowCollapse="false"
                :showForm="false"
                :crop="false"
              />
            </b-col>
          </b-row>
          <b-row v-if="modalMode === 'sendMessage'">
            <b-col cols="12">
              <b-form-group
                :label="$lang.ticketLang.message_sms"
                label-for="message_description"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.ticketLang.message_sms"
                  :rules="$v.message_description.$params"
                />
                <b-form-textarea
                  data-testid="message_description"
                  type="text"
                  name="message_description"
                  autocomplete="off"
                  :state="
                    $v.message_description.$dirty
                      ? !$v.message_description.$error
                      : null
                  "
                  v-model="$v.message_description.$model"
                ></b-form-textarea>
                <b-form-invalid-feedback id="name-feedback"
                  >{{
                    $lang.ticketLang.error_required
                      | replace($lang.ticketLang.message_sms)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="modalMode === 'targetUnit'">
            <b-col cols="12">
              <b-form-group
                :label="$lang.ticketLang.target_unit_all"
                label-for="target_unit_all"
                :label-cols="$config.form.labelCol"
              >
                <requiredComponent
                  slot="label"
                  :label="$lang.ticketLang.target_unit_all"
                  :rules="$v.ticket_unit_selected.$params"
                  :showInfo="true"
                  :titleText="``"
                />
                <selectFind
                  :options="ticket_unit_options"
                  v-model="$v.ticket_unit_selected.$model"
                  label="text"
                  id="value"
                  :isValid="
                    $v.ticket_unit_selected.$dirty
                      ? !$v.ticket_unit_selected.$error
                      : null
                  "
                />
                <b-form-invalid-feedback
                  :style="{
                    display: $v.ticket_unit_selected.$error ? 'block' : 'none',
                  }"
                  id="ticket_unit_selected_feedback"
                >
                  {{
                    $lang.ticketLang.error_required
                      | replace($lang.ticketLang.ticket_unit_selected)
                  }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
        </b-overlay>

        <template v-slot:modal-footer>
          <b-button class="ml-2" size="md" variant="danger" @click="closeModal">
            {{ $lang.ticketLang.cancelButton }}
            <i class="fa fa-ban" />
          </b-button>
          <b-overlay
            :show="btnloading || loading"
            spinner-small
            spinner-variant="primary"
            class="d-inline-block"
          >
            <b-button
              v-if="modalMode !== 'uploadFiles'"
              @click="
                modalMode === 'targetUnit' ? changeTicketUnit() : postSms()
              "
              class="float-right"
              variant="primary"
              :disabled="btnloading || loading"
            >
              {{ $lang.ticketLang.send }}
              <i class="fa fa-check" />
            </b-button>
          </b-overlay>
        </template>
      </b-modal>
      <confirm
        v-model="confirmData.show"
        :title="confirmData.title"
        :description="confirmData.description"
        :ok-title="$lang.ticketLang.yes"
        :cancel-title="$lang.ticketLang.no"
        dynamicClass=""
        @ok="$emit('changeState')"
        @cancel="confirmData.show = false"
      />
    </b-row>
    <b-row v-else>
      <b-col>
        <b-alert show variant="danger" class="font-weight-bold">
          <i class="fas fa-info-circle mr-2" />
          <span v-text="'هیچ اطلاعاتی وجود ندارد.'" />
        </b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import { required, requiredIf } from "vuelidate/lib/validators";
import { nl2br } from "@/shared/utils";
import confirm from "@/components/base/confirm";
import UploadFile from "@/components/base/uploadFile";
import AttachFile from "@/components/base/attachFile";
import { ProfileBoxPopupWrapper } from "@/components/re-design";

export default {
  validations: {
    description: {},
    ticket_status_selected: {
      required: requiredIf((vm) => {
        !!(vm.accessLevel === "admin");
      }),
    },
    ticket_unit_selected: {},
    message_description: {},
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    btnloading: {
      type: Boolean,
      defualt: false,
    },
    accessLevel: {
      type: String,
      default: "admin",
    },
  },
  components: {
    UploadFile,
    AttachFile,
    confirm,
    ProfileBoxPopupWrapper,
  },
  data() {
    return {
      description: null,
      ticket_status_selected: null,
      ticket_unit_selected: {},
      parentPermissions: ["view"],
      file_types: ["image", "office"],
      viewModal: false,
      modalMode: "",
      message_description: null,
      sampleAvatar: this.$config.images.shared.noPerson,
      file_id: null,
      acceptFormats: [
        {
          caption: "عکس",
          value: "1MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "1MB",
        },
      ],
      loading: false,
      term: null,
      parvande_number: null,
      confirmData: {
        show: false,
        title: this.$lang.ticketLang.end_ticket,
        description: `با خاتمه درخواست فقط درخواست قابل مشاهده خواهد بود و امکان اضافه کردن پیام و پیگیری پیام‌های قبلی آن وجود نخواهد داشت ضمنا درخواست توسط پشتیبان‌ها بررسی نخواهد شد و باید برای پیگیری موضوع این درخواست یا موضوعات دیگر درخواست جدید زده شود.
          <br>
          لطفا فقط زمانی درخواست را خاتمه دهید که موضوع مطرح شده در آن به نتیجه رسیده باشد.
          <br>
          <strong>با توجه به در نظر گرفتن تمام نکات گفته شده آیا از خاتمه درخواست مطمئن هستید ؟</strong>
        `,
      },
    };
  },
  computed: {
    senderName() {
      let name = pathOr("", ["user", "name"], this.item);
      if (pathOr(null, ["user", "person_cooperation"], this.item)) {
        name += ` (${this.item.user.person_cooperation})`;
      }
      return name;
    },
    ticket_status_options() {
      return renderEumOptions("ticket_status");
    },
    ticket_unit_options() {
      return renderEumOptions("ticket_unit");
    },
  },
  methods: {
    pathOr,
    nl2br,
    hasAttachment(item) {
      return (
        pathOr(false, ["has_attachment"], item) &&
        pathOr(false, ["ticket_sender_group", "id"], item) !== 1
      );
    },
    getUserRoles(id = 3, key = "role") {
      const roles = [
        { id: 0, role: "", icon: "", bgClass: "", name: "" },
        {
          id: 1,
          role: "کاربر",
          icon: "fas fa-user",
          bgClass: "bg-info",
          name: "شما",
        },
        {
          id: 2,
          role: "پشتیبان",
          icon: "fas fa-headset",
          bgClass: "bg-success",
          name: "پشتیبان",
        },
        {
          id: 3,
          role: "سیستم",
          icon: "fas fa-desktop",
          bgClass: "bg-dark",
          name: "سیستم",
        },
      ];
      const item = roles.find((role) => role.id === id);
      return item[key] || "";
    },
    errorImg(e) {
      if (e.type == "error") {
        e.target.src = this.$config.images.shared.noPerson;
      }
    },
    setResponseCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    closePage() {
      this.$router.go(-1) || window.close();
    },
    async changeTicketUnit() {
      let payload = {
        ticket_unit_id: pathOr(null, ["value"], this.ticket_unit_selected),
      };
      this.$emit("changeTicketUnit", payload);
    },
    handleModal(modalMode) {
      this.modalMode = modalMode;
      this.viewModal = !this.viewModal;
    },
    closeModal() {
      this.viewModal = false;
    },
    openModal(detail) {
      this.modalMode = "uploadFiles";
      this.file_id = detail.id.toString();
      this.viewModal = true;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      let payload = {
        description: this.description,
        ticket_status_id: pathOr(null, ["value"], this.ticket_status_selected),
      };

      this.$emit("submit", payload);
      this.description = "";
    },
    postSms() {
      let payload = {
        description: this.message_description,
      };

      this.$emit("postSms", payload);
      this.message_description = "";
      this.viewModal = false;
    },
    fetchData() {
      if (pathOr(null, ["details", "length"], this.item)) {
        this.ticket_status_selected = this.ticket_status_options.find(
          (x) => x.value === pathOr(null, ["ticket_status_id", "id"], this.item)
        );
        this.ticket_unit_selected = this.ticket_unit_options.find(
          (x) => x.value == pathOr(null, ["ticket_unit_id", "id"], this.item)
        );
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>

<style lang="scss" scoped>
/* m3hdi */
.message_card {
  .user_avatar {
    width: 50px !important;
    height: 50px !important;
  }
  .name {
    strong,
    caption {
      width: max-content;
    }
  }
}
.attach_file_box {
  border-radius: 4px;
}
@media (max-width: 575.98px) {
  .border_sm_none {
    border: none !important;
  }
}
/* ---- */
#chat-container {
  background: #eff3f7;
  margin: 0 auto;
  font-size: 0;
  border-radius: 5px;
  overflow: hidden;
}

aside {
  width: 260px;
  height: 800px;
  background-color: #3b3e49;
  display: inline-block;
  font-size: 15px;
  vertical-align: top;
}

main {
  width: 100%;
  /* height: 800px; */
  display: inline-block;
  font-size: 15px;
  vertical-align: top;
}

aside header {
  padding: 30px 20px;
}

aside input {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0 50px 0 20px;
  background-color: #5e616a;
  border: none;
  border-radius: 3px;
  color: #fff;
  background-image: url(https://s3-us-west-2.amazonaws.com/s.cdpn.io/1940306/ico_search.png);
  background-repeat: no-repeat;
  background-position: 170px;
  background-size: 40px;
}

aside input::placeholder {
  color: #fff;
}

aside ul {
  padding-left: 0;
  margin: 0;
  list-style-type: none;
  overflow-y: scroll;
  height: 690px;
}

aside li {
  padding: 10px 0;
}

aside li:hover {
  background-color: #5e616a;
}

h2,
h3 {
  margin: 0;
}

aside li img {
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 8px;
}

aside li div {
  display: inline-block;
  vertical-align: top;
  margin-top: 12px;
}

aside li h2 {
  font-size: 14px;
  color: #fff;
  font-weight: normal;
  margin-bottom: 5px;
}

aside li h3 {
  font-size: 12px;
  color: #7e818a;
  font-weight: normal;
}

.status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 57px;
}

/* @media (max-width: 767px) {
    .status {
      margin-right: 10px;
    }
  } */

.green {
  background-color: #58b666;
}

.orange {
  background-color: #ff725d;
}

.blue {
  background-color: #6fbced;
  margin-right: 0;
  margin-left: 7px;
}

main header {
  padding: 20px;
}

main header > * {
  display: inline-block;
  vertical-align: top;
}

main header img:first-child {
  border-radius: 50%;
}

main header img:last-child {
  width: 24px;
  margin-top: 8px;
}

main header div {
  margin-left: 10px;
  margin-right: 10px;
}

main header h2 {
  font-size: 16px;
  margin-bottom: 5px;
}

main header h3 {
  font-size: 14px;
  font-weight: normal;
  color: #7e818a;
}

#chat {
  padding-left: 0;
  margin: 0;
  list-style-type: none;
  overflow-y: scroll;
  height: 335px;
  border-top: 2px solid #fff;
  border-bottom: 2px solid #fff;
}

#chat li {
  padding: 10px 30px;
}

#chat h2 {
  display: inline-block;
  font-size: 13px;
  font-weight: normal;
  margin: 0 10px;
}

#chat h3 {
  font-size: 13px;
  font-weight: normal;
  margin-right: 55px;
  /* margin-top: 8px; */
}

#chat h3 {
  color: #607d8b;
}

#chat .entete {
  margin-bottom: 5px;
}

#chat .message {
  padding: 20px;
  color: #fff;
  line-height: 25px;
  max-width: 80%;
  display: inline-block;
  text-align: right;
  border-radius: 5px 0px 5px 5px;
}

#chat .me {
  text-align: right;
}

#chat .you .message {
  background-color: #6fbced;
}

#chat .me .message {
  background-color: #58b666;
}

#chat .mashin .message {
  background-color: cadetblue;
}

#chat .mashin .message {
  background-color: #d8c83d;
}

#chat .triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 10px 10px 10px;
  margin-right: 75px;
}

#chat .you .triangle {
  border-color: transparent transparent #6fbced transparent;
  margin-left: 95px;
}

#chat .me .triangle {
  border-color: transparent transparent #58b666 transparent;
  margin-left: 375px;
}

#chat .mashin .triangle {
  border-color: transparent transparent #d8c83d transparent;
  margin-right: 77px;
  margin-left: auto;
}

main footer {
  /* height: 155px; */
  padding: 0px 30px;
}

main footer textarea {
  resize: none;
  border: none;
  display: block;
  width: 100%;
  height: 80px;
  border-radius: 3px;
  padding: 20px;
  font-size: 13px;
  margin-bottom: 13px;
}

main footer textarea::placeholder {
  color: #ddd;
}

main footer img {
  height: 30px;
  cursor: pointer;
}

main footer a {
  text-decoration: none;
  text-transform: uppercase;
  font-weight: bold;
  color: #6fbced;
  vertical-align: top;
  margin-left: 333px;
  margin-top: 5px;
  display: inline-block;
}

#chat::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

#chat::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

#chat::-webkit-scrollbar-thumb {
  background-color: black;
}

.header-text {
  font-size: 14px;
  font-weight: normal;
  color: #7e818a;
}

.image-avatar {
  height: 60px;
  border-radius: 60%;
  margin: 0 0 0 10px;
  box-shadow: 2px 4px 10px 1px grey;
  float: right;
}

textarea.form-control {
  height: auto;
  overflow: auto;
  resize: vertical;
}

#chat > .you > .entete {
  margin-bottom: 5px;
  text-align: left;
}

.you > .image-avatar {
  float: left;
  margin: 0 10px 0 0px;
}

#chat > .you > .message {
  /* box-shadow: 2px 2px 7px 0px #616161; */
  padding: 20px;

  color: #fff;
  line-height: 25px;
  max-width: 80%;
  display: inline-block;
  text-align: right;
  border-radius: 0px 5px 5px 5px;
  float: left;
}

.you > .entete > .status {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 57px;
  margin-right: 0px;
}

.you-triangle {
  width: 100%;
  direction: ltr;
}

#chat .you h3 {
  text-align: left;
  margin-right: 0px;
  direction: rtl;
  margin-left: 70px;
  clear: left;
}

@media (max-width: 991px) {
  .image-avatar {
    display: none;
  }

  .status {
    margin-right: 15px;
  }

  #chat .mashin .triangle {
    margin-right: 15px;
  }
  .you > .entete > .status {
    margin-left: 15px;
  }
  #chat .you .triangle {
    margin-left: 15px;
  }
  #chat h3 {
    margin-right: 15px;
  }
  #chat .you h3 {
    margin-left: 15px;
  }
  #chat .triangle {
    margin-right: 55px;
  }
}

@media (max-width: 767px) {
  .status {
    margin-right: 10px;
  }

  #chat .triangle {
    margin-right: 25px;
  }

  #chat h3 {
    margin-right: 5px;
  }

  .you > .entete > .status {
    margin-left: 10px;
  }

  #chat .you .triangle {
    margin-left: 25px;
  }

  #chat .you h3 {
    margin-left: 0px;
  }
  #chat {
    height: auto;
  }
}
</style>
